import api from "./axiosInstance";

export const registerTutor = (form) => {
  const formData = new FormData();

  formData.append("data", JSON.stringify(form));

  form.educationalQualifications.forEach((q, index) => {
    if (q.document) {
      formData.append(`qualification_${index}`, q.document);
    }
  });

  form.certifications.forEach((c, index) => {
    if (c.document) {
      formData.append(`certification_${index}`, c.document);
    }
  });

  return api.post("/tutorsRegistration/register", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });
};

export const getAllTutors = () => {
  return api.get("/tutors/tutors");
};

export const getTutorById = (id) => {
  return api.get(`/tutors/tutors/${id}`);
};

export const tutorLogin = (data) => {
  return api.post(`/tutors/login`, data);
};

export const tutorForgotPassword = (email) => {
  return api.post(`/tutorsRegistration/forgot-password`, { email });
};

export const verifyResetCode = (email, code) => {
  return api.post(`/tutorsRegistration/verify-reset-code`, { email, code });
}
export const resetParentPassword = (email, code, newPassword) => {
  return api.post(`/tutorsRegistration/reset-password`, { email, code, newPassword });
}

export const getTutorProfile = (id) => {
  return api.get(`/tutorsRegistration/profile/${id}`);
};

export const updateTutorProfile = (id, formData) => {
  return api.put(`/tutorsRegistration/profile/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const tutorSocialLogin = (idToken, provider) => {
  return api.post(`/tutors/social/${provider}`, { idToken });
};